var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1577 21.5863V18.5196C9.15769 17.7396 9.79361 17.1058 10.5815 17.1005H13.4676C14.2592 17.1005 14.901 17.7359 14.901 18.5196V18.5196V21.5959C14.9008 22.2581 15.4347 22.7994 16.1035 22.8149H18.0276C19.9456 22.8149 21.5005 21.2756 21.5005 19.3768V19.3768V10.6528C21.4902 9.90577 21.136 9.20429 20.5385 8.74797L13.9582 3.50024C12.8054 2.58651 11.1667 2.58651 10.0139 3.50024L3.46251 8.7575C2.86275 9.21196 2.50787 9.91461 2.50049 10.6623V19.3768C2.50049 21.2756 4.05536 22.8149 5.9734 22.8149H7.89745C8.58284 22.8149 9.13846 22.2649 9.13846 21.5863V21.5863",
    stroke: "#CBCBCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.d81dca69ba1e29fed9e0cddbb1ccfa12.svg";
export { ForwardRef as ReactComponent };